import React from "react"
import MaterialModal from "../../MaterialModal"
import { Row } from "antd"
import closeIcon from "app/styles/images/sp/close.svg"
import deleteWarningIcon from "app/styles/images/sp/delete-warning.svg"

export default props => (
  <MaterialModal
    width={500}
    visible={props.visible}
    action={props.action}
    title="页面关闭确认"
    className="upload-quit-modal"
    buttonType="primary"
    buttonText="确认关闭">
    <img
       className="pgx-modal-close"
       src={closeIcon}
       alt="关闭对话框"
       onClick={props.onCancel}
     />
    <Row className="warning-line1" type="flex" justify="center" align="middle" gutter={8}>
      <img src={deleteWarningIcon} alt="" />
      <div>此时关闭页面，已添加数据不会被保存，您确认要关闭吗？</div>
    </Row>
  </MaterialModal>
)



// WEBPACK FOOTER //
// ./src/app/components/normal/BasicModal/UploadModal/QuitModal.js